import Form from './form.vue';
import FormItem from './form-item.vue';


export {
    Form,
    FormItem,
};


// WEBPACK FOOTER //
// ./src/components/form/index.js